module.exports = __webpack_public_path__ + "static/media/S1_00029.cebbdc96.jpg";